import * as actionTypes from '../actions/actionsTypes';

const initialState = {
  timezoneList: {
    data: []
  }
};


export const timezoneListReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_TIME_ZONE_LIST:
      return {
        ...state,
        timezoneList: action.payload,
      };
    default:
      return state;
  }
};

